/**
 * Presentation Library Search Agent - Tools Section
 * 
 * Standard tools section with preamble and postamble from Keywords AI.
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import type { ToolBase } from '../../../base/toolBase';
import { IN_PRESENTATION_SEARCH_PROMPT_KEYS } from './variables';

// ═══════════════════════════════════════════════════════════════════════════
// TOOLS PREAMBLE
// ═══════════════════════════════════════════════════════════════════════════

class PresentationLibrarySearchToolsPreambleSection extends PromptSectionBase {
    protected readonly keywordsKey = IN_PRESENTATION_SEARCH_PROMPT_KEYS.toolsPreamble;
    protected readonly fallbackContent = `## Available Tools

You have access to the searchPresentation tool for finding examples across PowerPoint presentations.`;
}

const toolsPreambleSection = new PresentationLibrarySearchToolsPreambleSection();

export function getToolsPreamble(): string {
    return toolsPreambleSection.getContent();
}

// ═══════════════════════════════════════════════════════════════════════════
// TOOLS POSTAMBLE
// ═══════════════════════════════════════════════════════════════════════════

class PresentationLibrarySearchToolsPostambleSection extends PromptSectionBase {
    protected readonly keywordsKey = IN_PRESENTATION_SEARCH_PROMPT_KEYS.toolsPostamble;
    protected readonly fallbackContent = `**Instructions:**
1. Analyze the requirements to determine the best search type
2. Choose appropriate result types based on what's being requested
3. Execute searches using the searchPresentation tool
4. When satisfied with results, call submitResults with findings`;
}

const toolsPostambleSection = new PresentationLibrarySearchToolsPostambleSection();

export function getToolsPostamble(): string {
    return toolsPostambleSection.getContent();
}

// ═══════════════════════════════════════════════════════════════════════════
// TOOLS SECTION BUILDER
// ═══════════════════════════════════════════════════════════════════════════

export function buildToolsSection(tools: ToolBase[]): string {
    const parts: string[] = [];
    
    // 1. Preamble
    parts.push(getToolsPreamble());
    parts.push('');
    
    // 2. Individual tool descriptions
    for (const tool of tools) {
        parts.push(tool.systemPromptDescription);
        parts.push('');
    }
    
    // 3. Postamble
    parts.push(getToolsPostamble());
    
    return parts.join('\n');
}
